import { observer } from 'mobx-react-lite'
import { useParams } from 'react-router'
import { useEffect } from 'react'
import PageLayout from '../../PageLayout'
import clubStore from '../../../storage/ClubStore'
import systemStore from '../../../storage/SystemStore'

const TrainingClass = () => {
  const { team_id, date } = useParams()

  useEffect(() => {
    clubStore.trainer.getClass(team_id, date)
  }, [team_id, date])

  const cls = clubStore.trainer.class

  return (
    <PageLayout
      header={
        <div className="flex flex-column">
          <h3 className="m-0">{cls.team_name}</h3>
          <span className="text-500 text-sm">{cls.class_date}</span>
        </div>
      }
    >
      <div className="grid">
        {cls.participants?.map((p) => (
          <div key={p.company_user_id} className="col-12 border-b">
            <div
              className={`card p-2 flex align-items-center justify-content-between cursor-pointer`}
              onClick={() =>
                !systemStore.loading &&
                clubStore.trainer.toggleParticipation(p.team_class_id, p.company_user_id).then(() =>{
                    clubStore.trainer.getClass(team_id, date)
                })
              }
            >
              {/* Left: Name */}
              <div className={`${p.participated ? 'text-600' : 'text-400'}`}>
                {p.name}
              </div>

              {/* Right: Status */}
              <i
                className={`pi text-xl
                  ${p.participated ? 'pi-check-circle text-green-600' : 'pi-circle text-400'}`}
              />
            </div>
          </div>
        ))}
      </div>
    </PageLayout>
  )
}

export default observer(TrainingClass)
